export default function Loader() {
  return (
    <div className="Loading">
      <div className="sub">
        <img src="./assets/img/SE-loading.png" className="mylogo" alt="imag" />
      </div>
    </div>
  );
}
